import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Photos from "../pages/photos/page";
import About from "../pages/about/page";
import Contact from "../pages/contact/page";
import Offerte from "../pages/offerte/page";
import Servizi from "../pages/servizi/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/photos",
    element: <Photos />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },
  {
    path: "/offerte",
    element: <Offerte />,
  },
  {
    path: "/diensten",
    element: <Servizi />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
